import { Component, OnInit } from '@angular/core';
import { SearchService } from '../../services/search';
import { MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { AppConfigService } from '../../app.config';
import { SearchDocusignService } from '../../services/search-docusign';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-search-docusign',
    templateUrl: 'search-docusign.html',
    styleUrls: ['search-docusign.css']
})

export class SearchDocusignComponent implements OnInit {

    results: any[];
    query: string;
    status = 'loading';
    dataSource: MatTableDataSource<any>;
    displayedColumns = ['id', 'first-name', 'last-name', 'email'];

    constructor(private config: AppConfigService,
        private search: SearchDocusignService,
        private router: Router,
        private http: HttpClient) { }

    ngOnInit() {
        this.status = '';
            this.search.collection$.subscribe((data: any[]) => {
                console.log(data);
                this.results = data;
                this.status =  `${data.length} results`;
        });

        this.search.error$.subscribe((data: any) => {
            this.status = 'No Records Found';
        });
      }

      getSearch() {

        if (this.query.length === 0 || !this.query.trim()) {
            return;
        }
        this.status = 'Searching...';

        if (this.query.includes('@')) {
            this.search.searchEmail(this.query.trim());
        } else {
            const name = this.query.split(' ');
            const fname = name[0];
            const lname = name.length > 1 ? name[1] : '';
            this.search.searchName(fname.trim(), lname.trim());
        }
      }

      rowClick(row: any) {
        // this.router.navigate(['/detail', row.personId]);
        window.open(`${this.config.host}:8081/detail/${row.personId}`);
      }

      open(url: any) {
        this.http.get(url, { responseType: 'blob'})
            .map(res => {
            return new Blob([res], { type: 'application/pdf', });
        })
        .subscribe((data) => {
            const tab = window.open();
            const fileUrl = URL.createObjectURL(data);
            tab.location.href = fileUrl;
        });

      }
}



// WEBPACK FOOTER //
// ./src/app/components/search-docusign/search-docusign.ts